import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CountrySite, Supplier, SupplierFilters, SuppliersManagementState } from './types'

export const initialState: SuppliersManagementState = {
  isLoading: false,
  suppliers: [],
  countrySites: [],
  filters: {
    siteId: '',
    type: '',
    search: '',
    includeInactive: false,
    page: 1,
  },
  lastPage: 1,
  total: 0,
  error: '',
  createStatuses: {},
}

export const SuppliersManagementSlice = createSlice({
  name: 'suppliersManagement',
  initialState,
  reducers: {
    updateSuppliersManagementIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    updateSuppliersManagementSuppliers: (state, action: PayloadAction<Supplier[]>) => {
      state.suppliers = action.payload
    },
    updateSuppliersManagementCountrySites: (state, action: PayloadAction<CountrySite[]>) => {
      state.countrySites = action.payload
    },
    updateSuppliersManagementFilters: (state, action: PayloadAction<Partial<SupplierFilters>>) => {
      const resetsPage = action.payload.page === undefined
      state.filters = { ...state.filters, ...action.payload, ...(resetsPage ? { page: 1 } : {}) }
    },
    updateSuppliersManagementPagination: (state, action: PayloadAction<{ lastPage: number; total: number }>) => {
      state.lastPage = action.payload.lastPage
      state.total = action.payload.total
    },
    updateSuppliersManagementError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
    },
    updateSuppliersManagementCreateStatuses: (state, action: PayloadAction<Record<string, string>>) => {
      state.createStatuses = action.payload
    },
    clearSuppliersManagement: () => initialState,
  },
})

export const {
  updateSuppliersManagementIsLoading,
  updateSuppliersManagementSuppliers,
  updateSuppliersManagementCountrySites,
  updateSuppliersManagementFilters,
  updateSuppliersManagementPagination,
  updateSuppliersManagementError,
  updateSuppliersManagementCreateStatuses,
  clearSuppliersManagement,
} = SuppliersManagementSlice.actions

export default SuppliersManagementSlice.reducer
